import {
  ARSL_DEFAULT_COLUMN_WIDTH,
  ArslActionAddBlankColumn,
  ArsListingColumn,
  ArsListingState,
} from "../interface";

/**
 * Inserts a new blank column at the specified index.
 *
 * @param state - Current ARS listing state
 * @param action - Add blank column action identifying the column index at which to insert
 * @returns Updated ARS listing state with the new column inserted
 */
export const arsl_addBlankColumn = <T>(
  state: ArsListingState<T>,
  action: ArslActionAddBlankColumn,
): ArsListingState<T> => {
  const newColumn: ArsListingColumn<T> = {
    id: action.colId,
    columnWidth: ARSL_DEFAULT_COLUMN_WIDTH,
    displayPattern: [state.settings.editorProps.blankT],
    headerText: state.settings.editorProps.blankT,
    resultPattern: "",
    variables: [],
  };
  const newColumns = [
    ...state.bodyData.arsListingColumns.slice(0, action.colIx),
    newColumn,
    ...state.bodyData.arsListingColumns.slice(action.colIx),
  ];

  return {
    ...state,
    changed: true,
    bodyData: {
      ...state.bodyData,
      arsListingColumns: newColumns,
    },
  };
};
